import React from 'react'
import styles from './BikeLayerToggle.scss'
import { settingsMessages } from 'common/MapV2/controls/SettingsMenu'
import { useFormatMessage } from 'lib/localization'
import cx from 'classnames'

export const BikeLayerToggle = ({ bikeLayer, toggle }) => {
  const fm = useFormatMessage()

  return (
    <div className={styles.bikeContainer}>
      <button onClick={toggle} className={cx(styles.BikeLayerToggle, bikeLayer && styles.active)}>
        {fm(settingsMessages.bikePaths)}
      </button>
    </div>
  )
}
